import { FC } from "react"
import { useParams } from "react-router-dom"

import { useTranslation } from "react-i18next"

import { PromotionEditorPage } from "components/promotions/PromotionEditorPage"

export const PromotionEdit: FC = () => {
  const { id } = useParams<{ id: string }>()
  const { t } = useTranslation("translation", { useSuspense: false })

  if (!id) {
    return <div className="p-8">{t("promotions.invalidId")}</div>
  }

  return <PromotionEditorPage mode="edit" id={id} />
}
